import { UserManagementTable } from './UserManagementTable'
import { withUserManagementTable } from './withUserManagementTable'

const ConnectedUserManagementTable =
  withUserManagementTable(UserManagementTable)
export { ConnectedUserManagementTable as UserManagementTable }
